import { mapGetters } from "vuex";
import { captchaShow } from "./captcha";

export const captchaMixin = {
  data() {
    return {
      // Local state if needed
      captchaOpen: false,
      captchaAppid: "",
    };
  },
  computed: {
    ...mapGetters(["webConfig", "captchaConfig"]),
  },
  created() {
    this.initializeCaptchaConfig();
  },
  methods: {
    initializeCaptchaConfig() {
      if (
        this.captchaConfig &&
        this.captchaConfig.web_and_app &&
        this.captchaConfig.web_and_app.CaptchaAppId
      ) {
        this.captchaAppid = this.captchaConfig.web_and_app.CaptchaAppId
          ? `${this.captchaConfig.web_and_app.CaptchaAppId}`
          : "";
      }
      this.captchaOpen = this.webConfig.captcha === 2;
    },
    captchaShow() {
      if (!this.captchaOpen) {
        return;
      }
      return captchaShow(this.captchaAppid);
    },
  },
};
